<ion-content class="ion-padding" slot="center">
  <div class="content-wrapper">
    <div class="login-container">
      <div class="logo-div">
        <img src="../../../../assets/images/rg_logo.svg" alt="logo" class="logo">
      </div>
      <h2 class="welcome-title">Welcome Back!</h2>
      
      <ng-container *ngIf="!isAdminLoginRoute">
        <!-- OTP Login Form -->
        <form *ngIf="loginMethod === 'otp'" [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()" class="otp-form">
          <ion-item class="input-item">
            <ion-label position="floating">Phone Number</ion-label>
            <ion-input type="tel" formControlName="mobile_number" appPhoneNumber required (ionInput)="onPhoneInput($event)"></ion-input>
          </ion-item>
          <div *ngIf="otpForm.get('mobile_number')?.invalid && (otpForm.get('mobile_number')?.touched || otpForm.get('mobile_number')?.dirty)" class="error-head">
            <small class="error-message" *ngIf="otpForm.get('mobile_number')?.errors?.['required']">Phone number is required.</small>
            <small class="error-message" *ngIf="otpForm.get('mobile_number')?.errors?.['pattern']">Invalid phone number format.</small>
          </div>

          <ion-item class="input-item" *ngIf="otpSent">
            <ion-label position="floating">Enter OTP</ion-label>
            <ion-input type="text" formControlName="otp" required></ion-input>
          </ion-item>

          <div class="resend-otp-container" *ngIf="otpSent">
            <ion-button *ngIf="canResendOtp" class="resend-otp-button" [disabled]="!canResendOtp" size="small" color="primary" fill="outline" (click)="sendVerifyOtp('send')">
              Resend OTP
            </ion-button>
            <p *ngIf="countdown > 0" class="resend-otp-text">Resend OTP in {{ countdown }} seconds</p>
          </div>
        
          <ion-button expand="full" type="submit" class="otp-button" [disabled]="loginMethod === 'otp' ? otpForm.invalid : loginForm.invalid">
            {{ otpSent ? 'Verify OTP' : 'Send OTP' }}
          </ion-button>
          
          <!-- Divider with 'or' text -->
          <div class="divider">
            <span>OR</span>
          </div>
          
          <!-- Samhita SSO Login -->
          <div class="samhita-login">
            <button type="button" (click)="loginWithSamhita()" class="samhita-button">
              <img height="30" src="../../../../assets/images/samhita_sso.png" alt="Samhita Logo" />
              <span class="samhita-text">Samhita AuthSam</span>
            </button>
          </div>
        </form>
      </ng-container>

      <div class="divider" *ngIf="isAdminLoginRoute">
        <span>Admin Login</span>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="isAdminLoginRoute">
        <ion-item class="input-item">
          <ion-label position="floating">Username or Email</ion-label>
          <ion-input type="text" formControlName="identifier" required></ion-input>
        </ion-item>
        <div *ngIf="loginForm.get('identifier')?.invalid && (loginForm.get('identifier')?.touched || loginForm.get('identifier')?.dirty)" class="error-head">
          <small class="error-message" *ngIf="loginForm.get('identifier')?.errors?.['required']">Username or email is required.</small>
        </div>

        <ion-item class="input-item">
          <ion-label position="floating">Password</ion-label>
          <ion-input type="password" formControlName="password" required></ion-input>
        </ion-item>
        <div *ngIf="loginForm.get('password')?.invalid && (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)" class="error-head">
          <small class="error-message" *ngIf="loginForm.get('password')?.errors?.['required']">Password is required.</small>
          <small class="error-message" *ngIf="loginForm.get('password')?.errors?.['minlength']">Password must be at least 6 characters long.</small>
        </div>

        <ion-button expand="full" type="submit" class="login-button" [disabled]="loginForm.invalid">Login</ion-button>
      </form>

      <!-- <div class="signup-link">
        <p>New User? <span (click)="movetoSignup()">Signup</span></p>
      </div> -->
    </div>
  </div>
</ion-content>